import {alpha, type Theme} from "@mui/material/styles";
import type {TFunction} from "i18next";
import {printoutPalette} from "../../core/printoutPalette";
import type {ColorPaletteOption} from "./toolbarControls";

export const getTextColorOptionGroups = (theme: Theme, t: TFunction): ColorPaletteOption[][] => [
    [
        {label: t('Default'), value: null},
    ],
    [
        {label: t('Black'), swatch: printoutPalette.primaryText, value: printoutPalette.primaryText},
        {label: t('Secondary gray'), swatch: printoutPalette.secondaryText, value: printoutPalette.secondaryText},
        {label: t('Muted gray'), swatch: printoutPalette.mutedText, value: printoutPalette.mutedText},
        {label: t('Hotel'), swatch: theme.palette.primary.main, value: theme.palette.primary.main},
    ],
    [
        {label: t('Green'), swatch: '#047857', value: '#047857'},
        {label: t('Blue'), swatch: '#2563EB', value: '#2563EB'},
        {label: t('Red'), swatch: '#B42318', value: '#B42318'},
    ],
];

export const getHighlightColorOptionGroups = (theme: Theme, t: TFunction): ColorPaletteOption[][] => {
    const hotelHighlightColor = alpha(theme.palette.primary.main, 0.18);

    return [
        [
            {label: t('No highlight'), value: null},
        ],
        [
            {label: t('Soft gray'), swatch: printoutPalette.subtleFill, value: printoutPalette.subtleFill},
            {label: t('Hotel'), swatch: hotelHighlightColor, value: hotelHighlightColor},
        ],
        [
            {label: t('Soft green'), swatch: '#D1FAE5', value: '#D1FAE5'},
            {label: t('Soft blue'), swatch: '#DBEAFE', value: '#DBEAFE'},
            {label: t('Soft red'), swatch: '#FEE2E2', value: '#FEE2E2'},
            {label: t('Marker yellow'), swatch: '#FEF08A', value: '#FEF08A'},
            {label: t('Soft amber'), swatch: '#FED7AA', value: '#FED7AA'},
        ],
    ];
};
